import { useSearchParams, Link } from "react-router-dom";

function PaymentSuccess() {
  const [searchParams] = useSearchParams();

  const paymentId = searchParams.get("payment_id");
  const bookingId = searchParams.get("booking_id");

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🎉 Payment Successful!</h1>

      <div style={styles.card}>
        <p><b> You will receive an invoice shortly on your email.</b></p>

        {paymentId && (
          <p><strong>Payment ID:</strong> {paymentId}</p>
        )}

        {bookingId && (
          <p><strong>Booking ID:</strong> {bookingId}</p>
        )}

        <Link to="/my-bookings">
          <button style={styles.btn}>View My Bookings</button>
        </Link>

        <Link to="/">
          <button style={styles.homeBtn}>Go to Home</button>
        </Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    marginTop: "50px",
  },
  title: {
    fontSize: "36px",
    fontWeight: "bold",
    paddingTop: "50px",
    marginBottom: "20px",
  },
  card: {
    display: "inline-block",
    padding: "30px",
    background: "white",
    borderRadius: "12px",
    border: "1px solid #ddd",
    width: "400px",
  },
  btn: {
    marginTop: "20px",
    padding: "10px 20px",
    background: "black",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontSize: "18px",
  },
  homeBtn: {
    marginTop: "10px",
    padding: "10px 20px",
    background: "gray",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontSize: "16px",
  },
};

export default PaymentSuccess;
